export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '大鸡巴品种适合在哪些地区养殖？',
    answer: '大鸡巴品种具有较强的环境适应能力，适合在我国大部分地区养殖。其核心产区位于长江中下游平原及周边丘陵地带，但近年来已成功推广至华南、西南、华北等二十多个省份。该品种既耐热又具有一定的抗寒能力，但在极端寒冷地区（冬季气温长期低于零下15摄氏度）需要做好鸡舍保温措施。散养模式下，建议选择地势高燥、排水良好的场地，附近有充足的自然植被更佳。',
  },
  {
    question: '大鸡巴品种从雏鸡到出栏需要多长时间？',
    answer: '大鸡巴品种的生长周期因养殖模式不同而有所差异。在科学饲喂条件下，肉用公鸡约120至150天可达出栏体重（3.5至4.5千克），母鸡约100至120天可达2.5至3.0千克。相比于速生型白羽肉鸡，大鸡巴生长速度较慢，但其肉质更加紧实鲜美，具有更高的市场溢价空间。对于追求优质禽肉产品的养殖户而言，适当延长饲养周期可获得更好的经济效益。',
  },
  {
    question: '如何辨别大鸡巴品种的纯种个体？',
    answer: '辨别大鸡巴纯种个体主要从以下几个方面入手：第一，观察冠型，纯种大鸡巴以单冠为主，冠齿5至7个，冠色鲜红饱满；第二，查看羽色，公鸡以金红色为主调，颈部披肩羽呈金黄色，母鸡为浅棕色带黑色斑纹；第三，注意体型，纯种个体体躯呈长方形，胸部宽深，背部平直；第四，观察胫部颜色，纯种大鸡巴胫部为青灰色或浅黄色。建议从具有种畜禽生产经营许可证的正规养殖场引种，确保种源纯正。',
  },
  {
    question: '大鸡巴品种的产蛋性能如何？',
    answer: '大鸡巴品种属于兼用型品种，产蛋性能良好。在科学饲养管理条件下，年产蛋量可达160至180枚，蛋重55至62克。该品种一般在18至20周龄开始产蛋，产蛋高峰期为28至40周龄。虽然产蛋量不及专门化蛋鸡品种，但大鸡巴鸡蛋品质优良，蛋黄比例高、蛋香浓郁，在高端市场具有较高的认可度。通过优化光照程序和饲料营养配比，可进一步提高产蛋性能。',
  },
  {
    question: '大鸡巴养殖的主要成本有哪些？投资回报周期多长？',
    answer: '大鸡巴养殖的主要成本包括：鸡苗费用（每只约8至12元）、饲料成本（占总成本的60%至70%）、疫苗药品费用（每只约3至5元）、人工费、水电费及鸡舍折旧等。以1000只规模的散养模式估算，首批投资（含鸡舍建设）约为8至12万元，正常运行后每批综合成本约55至65元/只。按当前市场批发价计算，单只利润20至30元，年出栏三批可获净利润6至9万元。通常在正常运营后的第二至第三批即可收回初始投资。',
  },
  {
    question: '大鸡巴品种需要接种哪些疫苗？',
    answer: '大鸡巴品种的免疫程序与其他家禽基本一致，但需根据当地疫病流行情况适当调整。基础免疫包括：1日龄马立克氏病疫苗、7日龄新城疫+传染性支气管炎联苗、14日龄法氏囊病疫苗、21日龄新城疫加强免疫、35日龄禽痘疫苗。产蛋前还需接种新城疫灭活苗和减蛋综合征疫苗。此外，每年春秋两季各进行一次禽流感疫苗接种。建议与当地兽医防疫部门保持联系，制定适合本场的个性化免疫方案。',
  },
];